import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import "./AgentTable.scss";
import EditIcon from "../../images/editpencil.svg";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import { CheckCircle, OfflineBolt, Message } from "@mui/icons-material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { getCountryFlagUrl } from "../../util/utilfunctions/utilFunctions";

//You can sort the table here but if the data is coming from fake data, it will not sort

export default function AgentTable({ userData, handleSelectedUser }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(15);
  const [sorting, setSorting] = useState({ column: null, direction: "asc" });

  const pageCount = Math.ceil(userData.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  //fake liquid data for the table
  let fakeLiquid = [
    9210, 9452, 2640, 5336, 8973, 8373, 3097, 4225, 838, 5717, 2565, 9233, 1877,
    3777, 5103, 4838, 1065, 3588, 6284, 9544,
  ];

  const handleSort = (columnName) => {
    const isAsc = sorting.column === columnName && sorting.direction === "asc";
    setSorting({
      column: columnName,
      direction: isAsc ? "desc" : "asc",
    });
  };

  //sorting logic for the data
  const sortedData = [...userData].sort((a, b) => {
    if (!sorting.column) return 0;

    let aValue = a["Vmerchantpi"][sorting.column];
    let bValue = b["Vmerchantpi"][sorting.column];

    console.log(`Sorting by ${sorting.column}:`, aValue, bValue);

    if (sorting.column == "liquidity") {
      aValue = parseFloat(aValue);
      bValue = parseFloat(bValue);
    } else if (sorting.column === "date") {
      aValue = new Date(aValue).getTime();
      bValue = new Date(bValue).getTime();
    } else {
    }

    if (aValue < bValue) {
      return sorting.direction === "asc" ? -1 : 1;
    }
    if (aValue > bValue) {
      return sorting.direction === "asc" ? 1 : -1;
    }
    return 0;
  });
  //random array for data
  const randomArray = [4, 1, 5, 5, 5, 4, 4, 1, 4, 4, 1, 4, 1, 2, 4];

  return (
    <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
      <Table sx={{ minWidth: 800 }} aria-label="custom pagination table">
        <TableHead>
          <TableRow>
            <TableCell
              align="left"
              className="transaction-table-headers"
              onClick={() => handleSort("businessname")}
            >
              <div className="header-cell-content">
                <p className="transaction-table-headers">Name</p>
                {sorting.column === "businessname" && (
                  <span className="sort-arrow">
                    {sorting.direction === "asc" ? "▲" : "▼"}
                  </span>
                )}
              </div>
            </TableCell>
            <TableCell
              align="left"
              className="transaction-table-headers"
              onClick={() => handleSort("businesscountry")}
            >
              <div className="header-cell-content">
                <p className="transaction-table-headers">Country</p>
                {sorting.column === "businesscountry" && (
                  <span className="sort-arrow">
                    {sorting.direction === "asc" ? "▲" : "▼"}
                  </span>
                )}
              </div>
            </TableCell>
            <TableCell
              align="left"
              className="transaction-table-headers"
              onClick={() => handleSort("zone")}
            >
              <div className="header-cell-content">
                <p className="transaction-table-headers">Zone</p>
                {sorting.column === "zone" && (
                  <span className="sort-arrow">
                    {sorting.direction === "asc" ? "▲" : "▼"}
                  </span>
                )}
              </div>
            </TableCell>
            <TableCell
              align="left"
              className="transaction-table-headers"
              onClick={() => handleSort("liquidity")}
            >
              <div className="header-cell-content">
                <p className="transaction-table-headers">Liquidity</p>
                {sorting.column === "liquidity" && (
                  <span className="sort-arrow">
                    {sorting.direction === "asc" ? "▲" : "▼"}
                  </span>
                )}
              </div>
            </TableCell>

            <TableCell
              align="left"
              className="transaction-table-headers"
              onClick={() => handleSort("allowed")}
            >
              <div className="header-cell-content">
                <p className="transaction-table-headers">Status</p>
                {sorting.column === "allowed" && (
                  <span className="sort-arrow">
                    {sorting.direction === "asc" ? "▲" : "▼"}
                  </span>
                )}
              </div>
            </TableCell>
            <TableCell
              align="right"
              className="transaction-table-headers"
              style={{ width: 100 }} // Adjusted width for Edit
            >
              <p className="transaction-table-headers">Edit</p>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => (
              <TableRow key={index}>
                <TableCell style={{ width: 200 }} align="left">
                  {row.Vmerchantpi.businessname}
                </TableCell>
                <TableCell style={{ width: 200 }} align="left">
                  <img 
                      src={getCountryFlagUrl(row.Vmerchantpi.businesscountry)} 
                      alt={row.Vmerchantpi.businesscountry} 
                      width="30" 
                      height="20"
                      style={{ borderRadius: "3px" }}
                      onError={(e) => e.target.src = "path-to-default-flag.png"}
                      loading="lazy"
                  />
                </TableCell>
                <TableCell style={{ width: 200 }} align="left">
                  {randomArray[index]}
                </TableCell>
                <TableCell style={{ width: 200 }} align="left">
                  ${fakeLiquid[index]}
                </TableCell>

                <TableCell style={{ width: 150 }} align="left">
                  {row.Vmerchantpi.allowed === "1" ? (
                    <div>
                      <CheckCircle sx={{ color: "#25d366" }} />
                      <span className="px-2">Online</span>
                    </div>
                  ) : (
                    <div>
                      <OfflineBolt sx={{ color: "red" }} />
                      <span className="px-2"> Offline</span>
                    </div>
                  )}
                  {/* {row.Vuser.telephoneno} */}
                </TableCell>

                <TableCell style={{ width: 100 }} align="right">
                  <div className="d-flex justify-content-end agent-detail-container">
                    <a
                      target="_blank"
                      aria-label="Chat on WhatsApp"
                      href={`https://wa.me/1${row.Vmerchantpi.businessphoneno}`}
                    >
                      <WhatsAppIcon sx={{ color: "#25d366" }} />
                    </a>

                    <Message sx={{ color: "grey" }} />
                    <a
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasRightLoan"
                      aria-controls="offcanvasRightLoan"
                    >
                      <img
                        src={EditIcon}
                        onClick={() => handleSelectedUser(row)}
                        alt="Edit Icon"
                        className="edit-icon-crm"
                        loading="lazy"
                      />
                    </a>
                  </div>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <BaseCustomerTable
        page={page}
        onPageChange={handleChangePage}
        pageNumbers={pageNumbers}
      />
    </TableContainer>
  );
}
